"use strict";

/*
* ***********************************Example of Usage***********************************
*
* 1 - ConfigListItem can receive up to three children
*     [0] - Content
*     [1] - Edit Prompt
*     [2] - Delete Prompt
*     This component will display the button if "onEdit" function prop is passed
*     the same happens with the Delete button.
*    <ConfigListItem
*      title="Equipe de Vendas"
*      onEdit={this.handleEdit}
*      onDelete={this.handleDelete}>
*      <Content />
*      <EditPrompt />
*      <DeletePrompt />
*    </ConfigListItem>
*
*
*/

var cx = require("classnames");
var PromptConfirmButtonGroup = require("app/shared/components/Prompt/prompt-confirm-button-group");
var Tooltip = require("app/shared/components/Tooltip/tooltip");
var Icon = require("app/shared/components/Icon/icon");

const ConfigListItem = (props) => {
  var classes = cx(
    props.className, 
    "config-list-item u-showOnHover-area"
  );

  var disabledClass = cx(
    {"o-50": props.disabled}
  );

  var showBadge = !props.syncStatus && !props.disabled;

  return (
    <li className={classes}>
      <div className="d-f">
        <strong className={`fs-18 fw-bold c-black ${disabledClass}`}>{props.title}</strong>
        {
          showBadge && 
          <Tooltip
            bottom
            html
            title={`<b>Atualizações pendentes.</b> <br/>Essa equipe foi alterada e os dados existentes ainda não foram atualizados.<br/>Clique no botão "Concluir e iniciar atualização" para concluir o processo`}
          >
            <div className="d-f align-center ml-5 fs-10 prl-5 ptb-5 br-8 c-dark-yellow bg-secondaySalmon fw-bold">
              <Icon custom icon="warning" className="fs-16 mr-5" />
              <span>pendente</span>
            </div>
          </Tooltip>
          
        }
        
      </div>
      <div className="pt-10 p-r">
        <div className={disabledClass}>
          {props.children}
        </div>
        <div className="r-10 b-0 p-a">
          <ConfigEdit 
            onEdit={props.onEdit}
            editPrompt={props.editPrompt} 
            disabled={props.disabled}
            disabledClass={disabledClass}
          />
          <ConfigDelete 
            onDelete={props.onDelete}
            deletePrompt={props.deletePrompt}
            disabled={props.disabled}
            disabledClass={disabledClass}
          />
        </div>
      </div>
    </li>
  );
};

ConfigListItem.propTypes = {
  title: React.PropTypes.string,
  className: React.PropTypes.string,
  children: React.PropTypes.node,
  editPrompt: React.PropTypes.node,
  deletePrompt: React.PropTypes.node,
  onEdit: React.PropTypes.func,
  onDelete: React.PropTypes.func,
  disabled: React.PropTypes.bool,  
  syncStatus: React.PropTypes.bool
}

ConfigListItem.defaultProps = {
  disabled: false,
  syncStatus: false
};

const ConfigEdit = (props) => {
  var hasEditFunction = typeof props.onEdit == "function";
  var hasEditPrompt = props.editPrompt;
  var tooltipMessage = props.disabled 
    ? "Para editar equipes será necessário aguardar a atualização de todos os dados finalizar. Tente novamente em alguns minutos."
    : "";

  if (hasEditFunction) {
    return <EditButton onClick={props.onEdit} disabled={props.disabled}/>;
  } else if (hasEditPrompt) {
    return (
      <Tooltip 
        bottom 
        title={tooltipMessage}
      >
        <PromptConfirmButtonGroup 
          className={`d-ib ${props.disabledClass}`} 
        >
          {props.editPrompt}
          <EditButton disabled={props.disabled} />
        </PromptConfirmButtonGroup>
      </Tooltip>
    );
  } else {
    return <noscript />;
  }
};

const ConfigDelete = (props) => {
  var hasDeleteFunction = typeof props.onDelete == "function";
  var hasDeletePrompt = props.deletePrompt;

  if (hasDeleteFunction) {
    return <DeleteButton onClick={props.onDelete} disabled={props.disabled} />;
  } else if (hasDeletePrompt) {
    return (
      <PromptConfirmButtonGroup 
        className={`d-ib ${props.disabledClass}`} 
      >
        {props.deletePrompt}
        <DeleteButton disabled={props.disabled} />
      </PromptConfirmButtonGroup>
    );
  } else {
    return <noscript />;
  }
};

const EditButton = (props) => (
  <ConfigButton onClick={props.onClick} text="Editar" disabled={props.disabled} />
);

const DeleteButton = (props) => (
  <ConfigButton onClick={props.onClick} text="Excluir" disabled={props.disabled} />
);

const ConfigButton = (props) => (
  <div className="u-showOnHover-target">
    <a onClick={props.disabled ? null : props.onClick} className="c-pointer ml-20">{props.text}</a>
  </div>
);

module.exports = ConfigListItem;



// WEBPACK FOOTER //
// ./app/shared/components/ConfigList/config-list-item.jsx